<template>
  <div
    class="tab-pane fade show active"
    id="nav-Recent"
    role="tabpanel"
    aria-labelledby="nav-Recent-tab"
    tabindex="0"
  >
    <div class="table-responsive table-datatble">
    <table class="table table-borderless dashboard-card-table">
      <thead class="thead-light">
      <tr>
        <th>Xếp hạng</th>
        <th>Vận động viên</th>
        <th>Hạng mục</th>
        <th>Điểm</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in data" :key="item.id">
        <td>
          <h2 class="table-avatar">
                <span class="table-head-name flex-grow-1">
                  <a data-bs-toggle="modal" data-bs-target="#upcoming-court">{{
                      index + 1 + (page - 1) * pageSize
                    }}</a>
                </span>
          </h2>
        </td>
        <td>
          <h5>
            {{
              `${item?.player?.first_name} ${
                  item?.player?.middle_name ?? ""
              } ${item?.player?.last_name}`
            }}
          </h5>
        </td>
        <td>
          <h6>{{ item?.round?.category?.name }}</h6>
        </td>
        <td>
          <h4>{{ item?.point }}</h4>
        </td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </div>
  </div>
</template>
<script>
import User_Rank from "@/assets/json/rank.json";
export default {
  props: {
    data: Array,
    page: Number,
    pageSize: Number,
  },
  data() {
    return {
      User_Rank: User_Rank,
    };
  },
  computed: {
    matchStatus() {
      return this.User_Rank.Status;
    },
    styleActive() {
      if (this.matchStatus !== "Kết thúc") {
        return "color: #ba2a33; background: rgba(186, 42, 51, 0.2);";
      } else {
        return " color: #097E52; background: rgba(27, 179, 51, 0.2);";
      }
    },
  },
};
</script>
